/**
 * We'll use this mixin to handle shared card crud oriented functionality.
 */

export default {
  methods: {
    returnToGroup() {
      this.$router.push('/group/' + this.getGroupId());
    },
    getGroupId() {
      return this.$route.params.id;
    }
  }
};
